import { Table } from "antd";
import type { TableRowSelection } from "antd/es/table/interface";
import { getPersonRecordKey } from "utils/getPersonRecordKey";

type Props = {
  isLoading: boolean;
  records: Array<any>;
  columns: Array<any>;
  rowSelection?: TableRowSelection<any>;
};

export const RosterAndStaffTable = ({ isLoading, records, columns, rowSelection = undefined }: Props) => {
  return (
    <Table
      loading={isLoading}
      size="small"
      tableLayout="fixed"
      style={{ width: "100%" }}
      scroll={{ x: "max-content" }}
      dataSource={records}
      rowKey={getPersonRecordKey}
      rowSelection={rowSelection}
      pagination={false}
      sortDirections={["ascend", "descend", "ascend"]}
      columns={columns}
    />
  );
};
